import { TextSelection } from "prosemirror-state";
const changeSelectionToEndOfTextBlock = (editor) => {
  const { $anchor } = editor.view.state.selection;
  const range = $anchor.blockRange();
  if (range) {
    const selectedText = TextSelection.create(editor.view.state.doc, range?.end - 1);
    editor.view.dispatch(editor.view.state.tr.setSelection(selectedText));
  }
};
export {
  changeSelectionToEndOfTextBlock
};
//# sourceMappingURL=change-selection-to-end-of-text-block.js.map
